import Popover from "lib/Popover";
import React, {useState } from "react";
import "./index.scss";
import { useEffect } from "react";
import { getWorkflowData} from "api/formDisplay";
import {checkMaxAttempts} from 'api/user'
import { useDispatch, useSelector } from "react-redux";
import { clearSelectedData } from "redux/formDisplay";

const PopoverDropdown = (props) => {
  const {
    handleItemClick,
    selectedData,
    value_key,
    disabled,
    options_key,
    is_conditional,
    check_attempts,
    id,
    role_id_list,
    user_id_list,
    is_searchable,
    fetch_reporting_manager,
    fetch_internal_poc
  } = props;
  const [showDropDown, setShowDropDown] = useState(false);
  const dispatch=useDispatch()
  const [numberofAttempts, setNumberofAttempts] = useState(0);
  const [disableField, setDisableField] = useState(false);
  const allUsersInfo = useSelector(
    (state) => state.dashboardReducer?.allUsers
  );
  
  const handleDropdownChange = (value) => {
    dispatch(clearSelectedData())
    setShowDropDown(() => value);
  };
  let options = is_conditional ? eval(options_key) : options_key
  let user_list =[];

    if(options_key == 'list_roles'){
      role_id_list.forEach((roleId)=>{        
        
        allUsersInfo?.forEach((user)=>{
          if(user?.role?.includes(roleId)){
            user_list.push({
              id: "assign_poc",
              label: user?.profile?.first_name + " " + user?.profile?.last_name,
              value: user._id,
              email: user?.email_id,
              mobile_number: user?.mobile_number
            });
          }
        })                   
      })
      
    }
  
  if(options_key == 'list_users'){
    user_id_list.forEach((userId)=>{        
      
      allUsersInfo?.forEach((user)=>{
        if(user?._id?.includes(userId)){
          user_list.push({
            id: "assign_poc",
            label: user?.profile?.first_name + " " + user?.profile?.last_name,
            value: user._id,
            email: user?.email_id,
            mobile_number: user?.mobile_number
          });
        }
      })                   
  })
  
}


  useEffect(() => {
    const fetchData = async() =>{
      if(check_attempts){
        let workflowInfo = await getWorkflowData(selectedData?.workflow_id)
        if(workflowInfo?.source_data?.[id + "_attempts"]?.number_of_attempts){
        setNumberofAttempts(workflowInfo?.source_data?.[id + "_attempts"]?.number_of_attempts)
        }
        let lastUpdatedAt = new Date(workflowInfo?.source_data?.[id + "_attempts"]?.last_updated_at)
        let enableAt = new Date(lastUpdatedAt.setMinutes(lastUpdatedAt.getMinutes() + check_attempts?.buffer_time_in_min));
        let currentDate = new Date()
        if(numberofAttempts == check_attempts?.max_attempts){
         if(currentDate < enableAt ){
          setDisableField(true)
         }else if(currentDate > enableAt ){
          let attemptObj = { 
            workflowId : selectedData?.workflow_id,
            name : id + "_attempts",
            reset : true
          }
           await checkMaxAttempts(attemptObj)
          setDisableField(false)
         }
        }
      }
    }
    fetchData()
  }, [numberofAttempts]);

  const checkMaximumAttempts =  async() => {
    let workflowInfo = await getWorkflowData(selectedData?.workflow_id)
    if(workflowInfo?.source_data?.[id + "_attempts"]?.number_of_attempts){
      setNumberofAttempts(workflowInfo?.source_data?.[id + "_attempts"]?.number_of_attempts)
      }
      if (check_attempts && numberofAttempts < check_attempts?.max_attempts) {
      const attemptObj = { 
        workflowId: selectedData?.workflow_id,
        name : id + "_attempts",       
        maxAttempts:check_attempts?.max_attempts,
        bufferTime: check_attempts?.buffer_time_in_min
      };
      await checkMaxAttempts(attemptObj);
    }

  }
  
  return (
    <>
    {((disabled && eval(disabled)) || disableField) ? (
        <div className="tooltip-wrapper">
          {disableField ? 
          <span className="tooltip-text">
            {check_attempts?.attempts_exceeds_message }
          </span>
          :''}
          {selectedData?.[value_key]}
        </div>
      ) : (
        <Popover
          trigger={
            <button className="add_column_button text-nowrap">
              {selectedData?.[value_key]}{" "}
              <i className={`fas fa-angle-${showDropDown ? "up" : "down"} fs-12px`}></i>
            </button>
          }
          show={showDropDown}
          children={selectedData?.[options] || user_list || []}
          handleToggle={handleDropdownChange}
          handleItemClick={handleItemClick}
          selectedData={selectedData}
          checkPocAttempts={check_attempts}
          checkMaximumAttempts={checkMaximumAttempts}
          fetchReportingManager={fetch_reporting_manager}
          options_key = {options_key}
          is_searchable = {is_searchable}
          fetch_internal_poc={fetch_internal_poc}
        />
      )}
    </>
  );
};

export default PopoverDropdown;
